export default __webpack_public_path__ + "static/media/abt.aa11a827.svg";